module.exports = __webpack_public_path__ + "img/icon_5_78.2d4d4ad6.png";